import { inject, Injectable } from '@angular/core';
import { ApiException, isUnityInternalProblem, isUnityNotFoundProblem } from '@unity/clients';
import { NavigationService } from '@unity/services/navigation.service';
import { ToasterService } from '@unity/services/toaster.service';
import { EMPTY, from, switchMap, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  private readonly navigationService = inject(NavigationService);
  private readonly toasterService = inject(ToasterService);

  public getErrorValidationMessage(displayName: string | null | undefined, errorKey: string, errorContext: unknown): string {
    switch (errorKey) {
      case 'required':
        return `${displayName} is required.`;
      case 'pattern':
        return `${displayName} does not match the pattern.`;
      case 'email':
        return `${displayName} is not a valid email address.`;
      case 'nonZero':
        return `${displayName} is required.`;
      case 'custom':
        return `${displayName} ${errorContext}.`;
      case 'serverError':
        return errorContext as string;
      default:
        return errorKey;
    }
  }

  public handleNotFound = (e: Error) => {
    if (ApiException.isApiException(e) && isUnityNotFoundProblem(e.result)) {
      return from(this.navigationService.notFound()).pipe(switchMap(() => EMPTY));
    } else {
      return throwError(() => e);
    }
  };

  public handleApiException = (e: Error) => {
    if (ApiException.isApiException(e) && isUnityInternalProblem(e.result)) {
      this.toasterService.showError('Server Error', e, 'error');
      return EMPTY;
    } else {
      return throwError(() => e);
    }
  };
}
